export enum AppRoutesType {
  unauthorized = 'unauthorized',
  onlyCognito = 'onlyCognito',
  public = 'public',
  private = 'private',
  conditionsConfirmation = 'conditionsConfirmation',
  banned = 'banned',
  onboarding = 'onboarding',
}